import { ReactNode } from 'react'

type Props = {
  children?: ReactNode
  index: number
  value: number
}

export const TabPanel = (props: Props) => {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  )
}
